"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
const _heading_1 = require("./_heading");
const ICONS = ['none', 'bike', 'truck', 'store', 'shield', 'clock', 'gift', 'credit-card', 'leaf', 'heart', 'star', 'tag', 'phone'];
(0, manifest_1.registerSection)({
    type: 'announcement', label: 'Announcement bar', icon: 'megaphone', category: 'header', singleton: true,
    settingsSchema: zod_1.z.object({
        text: zod_1.z.string().max(300).default(''),
        icon: zod_1.z.enum(ICONS).default('none'),
        linkLabel: zod_1.z.string().max(60).default(''),
        linkHref: zod_1.z.string().default(''),
        ..._heading_1.headingShape,
        ..._appearance_1.appearanceShape,
    }),
    defaults: () => ({ text: 'Free local delivery on qualifying orders', icon: 'none', linkLabel: '', linkHref: '', ...(0, _heading_1.headingDefaults)(), ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'text', label: 'Text', control: 'text', group: 'Content' },
        { name: 'icon', label: 'Icon', control: 'icon-enum', group: 'Content', options: ICONS.map((v) => ({ label: v === 'none' ? 'None' : v.replace('-', ' '), value: v })) },
        { name: 'linkLabel', label: 'Link label', control: 'text', group: 'Content' },
        { name: 'linkHref', label: 'Link URL', control: 'url', group: 'Content' },
        ..._heading_1.headingFields,
        ..._appearance_1.appearanceFields,
    ],
});
//# sourceMappingURL=announcement.js.map